import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Button, ButtonGroup, Card, CardBody, CardHeader, Col, Collapse, Container, Modal, ModalBody, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ApplicationState } from '../../store';
import { SessionModel } from '../../models/SessionModel';
import * as WidgetStore from '../../store/Widget';
import { WidgetIcon } from '../WidgetScreen/WidgetIcon';
import { LoadingIcon } from '../Misc/Loading';
import ARPicker from '../ARPicker/ARPicker';
import * as BillToMdl from '../../models/BillToModel';

type MyProps =
    {
        WidgetList: WidgetStore.WidgetList,
        SessionState: SessionModel 
    } & typeof WidgetStore.actionCreators;

interface MainWidgetState {
    menuOpen: boolean;
    toggleMenuProp?: any;
}

class MainWidgetScreen extends React.PureComponent<MyProps> {    
   
    componentDidMount() {
        this.props.loadWidgets(this.props.SessionState.SelectedAR.companyCode, this.props.SessionState.SelectedAR.id, this.props.SessionState.SelectedSM.id);
    }

    public render() {
      

        if (!this.props.WidgetList.loaded) {
            return (<div>Loading</div>); 
        } else {
            return (
                <Container fluid={true}>  
                <div style={{ paddingTop: "10px"}}>
                        <h3 className="center-align">
                            Good afternoon, {this.props.SessionState.SelectedAR.name.greetingName}
                    </h3>
                    <div>
                        
                            <Row><Col xs="6" style={{ paddingRight: '5px' }}>
                                <div className="widgetInfoAreaDetail">
                                    <Row className="widgetInfoAreaDetailLine1">
                                        <Col xs="7">
                                            <span>Bill To  {this.props.SessionState.SelectedAR.id}</span>
                                        </Col>
                                        <Col xs="5" className="right-align" style={{ color: "blue" }}>                                            
                                            <Link to={"/ARPicker"}>Change</Link>
                                        </Col>
                                    </Row>
                                    <div className="widgetInfoAreaDetailLine2">
                                        {this.props.SessionState.SelectedAR.name.displayName}<br />
                                        {this.props.SessionState.SelectedAR.address.line1}<br />
                                        {`${this.props.SessionState.SelectedAR.address.city}, ${this.props.SessionState.SelectedAR.address.state} ${this.props.SessionState.SelectedAR.address.zip}`}
                                    </div>                                    
                                </div>
                            </Col>
                                <Col xs="6" style={{ paddingLeft: '5px' }}>
                                    <div className="widgetInfoAreaDetail">
                                        <Row className="widgetInfoAreaDetailLine1">
                                            <Col xs="7">
                                                <span>Location {this.props.SessionState.SelectedSM.id} </span>
                                            </Col>
                                            <Col xs="5" className="right-align" style={{ color: "blue" }}>
                                                <Link to={"/SMPicker"}>Change</Link>
                                            </Col>
                                        </Row>
                                        <div className="widgetInfoAreaDetailLine2">
                                            {this.props.SessionState.SelectedSM.name.displayName}<br />
                                            {this.props.SessionState.SelectedSM.address.line1} <br/>
                                            {`${this.props.SessionState.SelectedSM.address.city}, ${this.props.SessionState.SelectedSM.address.state} ${this.props.SessionState.SelectedSM.address.zip}`}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                   
                    </div>
                    <div className="widgetMainContainer">
                            {this.props.WidgetList.items.map((item, index) => {
                                if (item.widgetInternalName != 'Add-User' || (item.widgetInternalName == 'Add-User'  && this.props.SessionState.SelectedAR.primaryAccount)) {                                
                                    return (<WidgetIcon widgetInfo={item} key={index}></WidgetIcon>);
                                }                            
                            }
                        )}
                    </div>                      
                    </div>
                </Container>
            );
        }
    }
}

export default connect(
    (state: ApplicationState) => ({ ...{ WidgetList: state.widgetListState }, ...{ SessionState: state.sessionState } }),
    WidgetStore.actionCreators)(MainWidgetScreen as any);